// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
// New Comment
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import router from './router/index'
import { loadScript } from 'esri-loader'
import store from './store/index'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import './main.css?version=6-29-18'

// Preload Esri API scripts using esri-loader
loadScript({url: 'https://js.arcgis.com/3.38/'})

Vue.use(Vuetify, {
  theme: 
    {
      primary: colors.blue.darken2,
      secondary: colors.lime.lighten2,
      accent: colors.purple.base,
      error: colors.red.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: '#7fd7ff'
    }
})



/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {  },
})

Vue.config.productionTip = false

export {app, router, store }





// WEBPACK FOOTER //
// ./src/main.js